<template>
  <div>
    <!-- 桌面端视图 -->
    <div v-if="!isMobile" class="desktop-container">
      <div class="google-reviews-widget-container">
        <!-- 标题区域 -->
        <div class="reviews-header">
          <h2>Google Reviews</h2>
            <!-- 星级评分为静态占位，Widget加载后可能覆盖 -->

          <!-- <div class="rating-summary">
            <div class="stars">
              <span v-for="n in 5" :key="n" class="star">★</span>
            </div>
            <span class="average-rating">5.0</span>
            <span class="total-reviews">(12 reviews)</span>
          </div> -->
        </div>

        <!-- Widget 容器 - 已简化，无干扰逻辑 -->
        <div class="widget-wrapper">
          <!-- Elfsight Widget 直接放在这里 -->
          <div class="elfsight-app-5a2e7513-2fce-42fa-a713-703be8bef6b0" data-elfsight-app-lazy></div>
        </div>

        <!-- 查看全部按钮 -->
          <!-- 重要：请将 YOUR_PLACE_ID_HERE 替换为您自己的Google Place ID -->

        <!-- <div class="view-more">
          <a
            href="https://search.google.com/local/reviews?placeid=YOUR_PLACE_ID_HERE"
            target="_blank"
            rel="noopener"
            class="view-all-btn"
          >
            View All Reviews on Google
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div> -->
      </div>
    </div>

    <!-- 移动端视图 -->
    <div v-else class="mobile-container">
      <div class="mobile-reviews-container">
        <!-- 标题区域 -->
        <div class="mobile-reviews-header">
          <h2>Google Reviews</h2>
          <!-- <div class="mobile-rating-summary">
            <div class="mobile-stars">
              <span v-for="n in 5" :key="n" class="mobile-star">★</span>
            </div>
            <span class="mobile-average-rating">5.0</span>
            <span class="mobile-total-reviews">(12 reviews)</span>
          </div> -->
        </div>

        <!-- 移动端 Widget 容器 -->
        <div class="mobile-widget-wrapper">
          <!-- 移动端使用同一个Elfsight Widget -->
          <div class="elfsight-app-5a2e7513-2fce-42fa-a713-703be8bef6b0" data-elfsight-app-lazy></div>
        </div>

        <!-- 移动端查看全部按钮 -->
          <!-- 重要：请将 YOUR_PLACE_ID_HERE 替换为您自己的Google Place ID -->

        <!-- <div class="mobile-view-more">
          <a
            href="https://search.google.com/local/reviews?placeid=YOUR_PLACE_ID_HERE"
            target="_blank"
            rel="noopener"
            class="mobile-view-all-btn"
          >
            View All Reviews
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleReviews',
  data() {
    return {
      isMobile: false, // 仅保留移动端检测状态
    }
  },
  mounted() {
    // 仅保留移动端检测逻辑
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    // 已移除所有会导致冲突的Widget加载检查逻辑
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 850;
    }
  }
}
</script>

<style scoped>
/* =============== 桌面端样式 =============== */
.desktop-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  min-width: 1349px;
  margin-top: 65px;
  background-color: white !important;
}

.google-reviews-widget-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 40px;
  background: white;
}

.reviews-header {
  text-align: center;
  margin-bottom: 50px;
}

.reviews-header h2 {
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
}

.rating-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.stars {
  color: #ffb400;
  font-size: 1.8rem;
  letter-spacing: 2px;
}

.average-rating {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.total-reviews {
  font-size: 1.1rem;
  color: #666;
}

/* Widget容器 */
.widget-wrapper {
  position: relative;
  margin: 30px 0;
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

/* 确保Elfsight Widget容器能正常伸展 */
.elfsight-app-5a2e7513-2fce-42fa-a713-703be8bef6b0 {
  width: 100%;
  min-height: 400px;
}

.view-more {
  text-align: center;
  margin-top: 20px;
}

.view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.view-all-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.4);
  gap: 15px;
}

/* =============== 移动端样式 =============== */
.mobile-container {
  width: 100%;
  margin-top: 60px;
  background-color: white;
  padding: 30px 0;
  overflow: hidden;
}

.mobile-reviews-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  background: white;
  box-sizing: border-box;
}

.mobile-reviews-header {
  text-align: center;
  margin-bottom: 30px;
}

.mobile-reviews-header h2 {
  color: #333;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: -0.3px;
}

.mobile-rating-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.mobile-stars {
  color: #ffb400;
  font-size: 1.4rem;
  letter-spacing: 1px;
}

.mobile-average-rating {
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
}

.mobile-total-reviews {
  font-size: 1rem;
  color: #666;
}

/* 移动端Widget容器 */
.mobile-widget-wrapper {
  position: relative;
  margin: 20px 0;
  min-height: 350px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.mobile-view-more {
  text-align: center;
  margin-top: 15px;
}

.mobile-view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  box-shadow: 0 3px 15px rgba(102, 126, 234, 0.3);
}

.mobile-view-all-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  gap: 12px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .mobile-reviews-container {
    padding: 0 15px;
  }
  
  .mobile-widget-wrapper {
    min-height: 320px;
  }
}

@media (max-width: 480px) {
  .mobile-reviews-header h2 {
    font-size: 1.5rem;
  }
  
  .mobile-stars {
    font-size: 1.2rem;
  }
  
  .mobile-average-rating {
    font-size: 1.1rem;
  }
  
  .mobile-total-reviews {
    font-size: 0.9rem;
  }
  
  .mobile-widget-wrapper {
    min-height: 300px;
  }
  
  .mobile-view-all-btn {
    padding: 10px 20px;
    font-size: 0.85rem;
  }
}
</style>